"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handlePhoneField = void 0;
const phone_1 = require("../enums/phone");
const handlePhoneField = ({ value, name, options, context }) => {
    if (options.phone) {
        switch (options.phone?.type) {
            case phone_1.AvailablePhoneHandlers.YAPE:
                return handleYapePhoneField({ value, name, options, context });
            default:
                return true;
        }
    }
    return true;
};
exports.handlePhoneField = handlePhoneField;
const handleYapePhoneField = ({ value, name, options, context }) => {
    const regex = /^(\d{3}\s\d{3}\s\d{3}|\d{9})\d*$/;
    const message = options.phone.message;
    if (regex.test(value)) {
        context.actions?.clearError(name);
        return true;
    }
    context.actions?.setError(name, { message });
    return false;
};
